import { Control, Controller } from "react-hook-form";

import { ICreateCompanyForm } from "../CompanyForm";
import { PrioritySelect, IPrioritySelectOption } from "../Selects";
import { FormLabel } from "@ui/FormElements";

interface IPriorityFormFieldProps {
  control: Control<ICreateCompanyForm>;
  options: IPrioritySelectOption[];
  onSave?: (value: IPrioritySelectOption | null) => void;
}

export function PriorityFormField({ control, options, onSave }: IPriorityFormFieldProps) {
  return (
    <Controller
      control={control}
      name="priority"
      render={({ field: { value, onChange } }) => (
        <div className="flex flex-col justify-between gap-0.5">
          <FormLabel htmlFor="priority">Priority</FormLabel>
          <div className="w-full">
            <PrioritySelect
              options={options}
              value={value}
              onChange={(option) => {
                onChange(option);
                onSave?.(option);
              }}
              className="w-full"
            />
          </div>
        </div>
      )}
    />
  );
}
